module.exports = __webpack_public_path__ + "static/img/HAMPTON-OAK.2a281fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/HAMPTON-OAK.png
// module id = yNmo
// module chunks = 0